<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <div class="row mt-4">
          <div class="col-md-2">
            <h4>Преимущества</h4>
          </div>
          <div class="col-md-2">
            <el-button type="success" @click="goToPage('advantage/create')">Создать новое преимущество</el-button>
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск" >
          <el-row>
            <el-col :span="10">
                <el-form-item label="Поиск по названию">
                    <el-col :span="14">
                        <el-input v-model="query.q" @change="setQueryReset"></el-input>
                    </el-col>
                </el-form-item>
            </el-col>
            <el-col :span="10">
                <el-form-item label="Сортировка">
                    <el-select v-model="query.sort" no-data-text="Нет данных" :width="300" @change="setQuery">
                        <el-option
                        v-for="item in sortConfig"
                        :key="item.field"
                        :value="item.field"
                        :label="item.title"
                        />
                    </el-select>
                </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-table
        :data="advantages"
        style="width: 100%"
        empty-text="Нет данных"
        >
            <el-table-column
                prop="id"
                label="Id"
                width="50"
            >
            </el-table-column>
            <el-table-column
                prop="title"
                label="Название"
            />
            <el-table-column
                prop="sort"
                label="Сортировка"
            />
            <el-table-column
                label="Активность"
            >
                <template slot-scope="scope">
                    <p v-if="!advantages[scope.$index].activity">Нет</p>
                    <p v-if="advantages[scope.$index].activity">Да</p>
                </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                label="Действия"
                width="400"
            >
                <template slot-scope="scope">
                    <el-button v-if="advantages[scope.$index].activity"
                        size="mini"
                        type="primary"
                        plain
                    @click="hideRow(scope.$index)">Скрыть</el-button>

                    <el-button v-if="!advantages[scope.$index].activity"
                        size="mini"
                        type="primary"
                        plain
                    @click="restoreRow(scope.$index)">Восстановить</el-button>

                    <el-button
                        size="mini"
                    @click="updateRow(scope.$index)">Изменить</el-button>

                    <el-button
                        size="mini"
                        type="danger"
                    @click.native.prevent="deleteRow(scope.$index)">Удалить</el-button>
                </template>
            </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
            background
            layout="prev, pager, next"
            :total="paginator.total"
            :current-page.sync="paginator.current"
            @current-change="getPage(current)"
            :hide-on-single-page="true"
            :page-size="paginator.per_page"
            :page-count="paginator.last_page"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../../composable/config/roots-sort.config"
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
name: "Advantages",
  data: function (){
    return{
      status:0,
      sortConfig,
      advantages:[],
      paginator: {},
      query:{
          q:'',
          sort: sortConfig[0].field,
          page: 1,
      }
    }
  },
  computed: {
    activeSort() {
        const result = this.sortConfig.find((e) => e.field === this.query.sort)
        return result ? result.options  : undefined
    },
  },
  mounted() {
    this.initParams(this.$route.query);
    this.getAdvantages(this.getQuery(this.$route.query));
  },
  watch:{
    '$route.query'(v){   
        const query = this.getQuery(v)   
            if (query){              
                this.getAdvantages(query)
            }
        }
    },          
  methods:{
    getAdvantages: function (query){        
        this.$store.commit(SETPRELOADER_STATE, true)        
        axios.get('advantage/' + query).then((response)=>
        {
            this.advantages = response.data.data;
            this.paginator = response.data.meta;
        }
        ).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
        })
        .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },
    getPage: function(pageNum){
        if(pageNum!==null){
            this.query.page = pageNum
            this.setQuery(); 
        }
    },

    goToPage: function (path){
        this.$router.push(path);
    },
    deleteRow: function (index) {
        let id = this.advantages[index].id;
        
        axios.delete('advantage/'+id).then(()=>{
            this.$notify.success('Приемущество удалено')
            this.updateItems();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });
    },
    hideRow: function (index) {
        let id = this.advantages[index].id;

        axios.post('advantage/'+id+'/hide').then(()=>{
            this.$notify.success('Приемущество скрыто')
            this.updateItems();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });
    },
    restoreRow: function (index) {
        let id = this.advantages[index].id;
        axios.post('advantage/'+id+'/restore').then(()=>{
            this.$notify.success('Приемущество востановлено')
            this.updateItems();
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
            this.$notify.error('Не предвиденная ошибка')
        });
    },
    updateRow: function (index) {
        let id = this.advantages[index].id;
        this.$router.push('/advantage/'+id+'/update');
    },

    async updateItems(){
        this.getAdvantages(this.getQuery(this.getQueryObj().obj))
    },

    getQueryObj(){
        const result = {}
        let isChange = false;
        if (this.activeSort) {
            isChange = true;
            result['sort']= {
                by: this.activeSort.by,
                order: this.activeSort.order
            }
        }
        if (this.query.q) {
            isChange = true;
            result['q']=this.query.q
        }
        if(this.query.page){
            isChange = true
            result['page']=this.query.page
        }

        return {
            isChange,
            obj: result,
        }
    },

    setQueryReset(){
        this.query.page = 1
        this.setQuery()
    },

    setQuery(){
        const result = this.getQueryObj()

        if (result.isChange) {
            const q = this.getQuery(result.obj)
            this.$router.push({
                path: 'advantages' + q,
            })
        }
    }, 
    getQuery(query) {
        if (Object.keys(query).length > 0){        
            const qs = require('qs');
            return `?${qs.stringify(query)}`
        }
        return ''
    },
    initParams(query){
        if (!query){
            return
        }

        const qs = require('qs');
        const parseQuery= qs.parse(query);


        if (parseQuery.sort?.by && parseQuery.sort?.order) {
            this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
        }
        if (parseQuery.q){
            this.query.q = parseQuery.q
        }
        if(parseQuery.page){
            this.query.page= parseQuery.page
        }
    }
  }
}
</script>

<style scoped>

</style>